"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icon_1 = require("../../Icon");
var Utilities_1 = require("../../Utilities");
var getClassNames = Utilities_1.classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardLogoBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardLogoBase, _super);
    function DocumentCardLogoBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardLogoBase.prototype.render = function () {
        var _a = this.props, logoIcon = _a.logoIcon, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.root },
            React.createElement(Icon_1.Icon, { iconName: logoIcon })));
    };
    return DocumentCardLogoBase;
}(Utilities_1.BaseComponent));
exports.DocumentCardLogoBase = DocumentCardLogoBase;
//# sourceMappingURL=DocumentCardLogo.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardLogo.base.js
// module id = 968
// module chunks = 0